import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom';
import {
  FiHome, FiSettings, FiMap, FiCpu,
  FiMenu, FiX, FiLogOut, FiUser, FiBell,
  FiDroplet
} from 'react-icons/fi';
import config from './config';
import NotifcationBell from './components/NotificationBell';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [clientData, setClientData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: FiHome },
    { name: 'Manage Farms', href: '/farms', icon: FiMap },
    { name: 'MCU Manager', href: '/mcu', icon: FiCpu },
    { name: 'Controller Manager', href: '/controllers', icon: FiCpu },
    { name: 'Sensors Manager', href: '/sensors', icon: FiDroplet },
    { name: 'MCU Settings', href: '/settings-profile', icon: FiSettings },
    { name: 'Settings', href: '/settings', icon: FiSettings },
  ];

  useEffect(() => {
    const storedClient = localStorage.getItem('client');
    if (storedClient) {
      setClientData(JSON.parse(storedClient));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('client');
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  if (isAuthPage) return <Outlet />;

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <div className={`fixed z-50 inset-y-0 left-0 w-64 bg-white shadow-lg transform lg:translate-x-0 lg:static transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r  rounded-lg flex items-center justify-center">
              
              <img src="/100.png" className='w-20' alt=''/>
            </div>
            <span className="text-xl font-bold text-gray-800">MushFarm</span>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-1 rounded-md text-gray-400 hover:text-gray-600"
          >
            <FiX size={20} />
          </button>
        </div>

        <nav className="flex-1 px-4 py-6 space-y-2">
          {navigation.map(({ name, href, icon: Icon }) => (
            <Link
              key={name}
              to={href}
              className={`flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive(href)
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
              onClick={() => setSidebarOpen(false)}
            >
              <Icon className="mr-3 h-5 w-5" />
              {name}
            </Link>
          ))}
        </nav>

        {/* User Profile & Logout */}
        <div className="p-4 border-t border-gray-200">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
              <FiUser className="text-gray-600" size={20} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">
                {clientData?.username || 'Guest'}
              </p>
              <p className="text-xs text-gray-500">
                {clientData?.email || 'No email'}
              </p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg"
          >
            <FiLogOut className="mr-3 h-4 w-4" />
            Sign Out
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1  min-h-screen">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
            >
              <FiMenu size={20} />
            </button>

            <h1 className="text-2xl font-semibold text-gray-900">
              {navigation.find(item => isActive(item.href))?.name || 'Dashboard'}
            </h1>

            <div className="flex items-center space-x-4">
              {/* <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg relative">
                <FiBell size={20} />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button> */}
               <NotifcationBell />
            </div>
          </div>
        </header>

        {/* Page Body */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
